module.exports = __webpack_public_path__ + "static/img/2.714b181.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-pt/2.jpg
// module id = 6clr
// module chunks = 1